<template lang="pug">
.dog-entry
    DocRefImage(v-if="dog.imageRef" :img-ref="dog.imageRef")
    img(v-else :src="DoggoImage")
    table
        tr
            td Name
            td {{ dog.name }}
        tr
            td Weight
            td {{ dog.weight || "unset" }} lbs ({{ dog.size }})
        tr
            td Breed
            td {{ dog.breed }}
        tr
            td Age
            td {{ dog.age || "unset" }}
    .data-value 
        VaccineStatus(:vax="dog.vaccines")
</template>

<script setup lang="ts">
import VaccineStatus from '@/components/vaccine-status.vue';
import DoggoImage from '@busy-human/k9-library/src/resources/doggo.svg';
import DocRefImage from './doc-ref-image.vue';
import { DataInstance } from '@busy-human/gearbox';
import { Dogspaces } from '@busy-human/k9-library';

type Props = {
    dog: DataInstance<Dogspaces.Model>
}
defineProps<Props>();

</script>

<style lang="scss">
.dog-entry {
    border: 1px solid black;
    padding: 1rem;
    border-radius: 2rem;
    width: 18rem;
    box-sizing: border-box;


    box-shadow: .2rem .2rem 0px black;
    background: white;

    transition: background-color .25s ease;

    table {
        td:first-child {
            font-size: .8em;
            font-weight: lighter;
            color: rgba(black, .6);
            float:right;
        }
    }

    img {
        object-fit: contain;
        width: 100%;
        aspect-ratio: 1 / 1;
    }

    &:hover {
        cursor: pointer;
        background: lightgray;
    }

    &:active {
        background: grey;
    }

    &.selected {
        border: 2px dashed red;
    }
}
</style>